/*global google*/
import React from 'react';
import axios from "axios";
import Select, { components } from "react-select";
import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import AdminHeaderNew from '../NewAdminPanel/Common/AdminHeader';
import AdminSideBarNew from '../NewAdminPanel/Common/AdminSidebarMnt';
import AdminFooterNew from '../NewAdminPanel/Common/AdminFooter';
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";

const SurveyDetail = () => {
    const [optionState, setOptionState] = useState([]);
    const [stateValue, setStateValue] = useState([]);
    const [optionDistrict, setOptionDistrict] = useState([]);
    const [districtValue, setDistrictValue] = useState('');
    const [optionSubDistrict, setOptionSubDistrict] = useState([]);
    const [subdistrictValue, setsubDistrictValue] = useState('');
    const [optionVillage, setOptionVillage] = useState([]);
    const [villageValue, setvillageValue] = useState('');
    const [selectedDataSetDistrict, setselectedDataSetDistrict] = useState('');
    const [selectedDataSetSubDistrict, setselectedDataSetSubDistrict] = useState('');
    const [selectedDataSetVillage, setselectedDataSetVillage] = useState('');
    const [selectedFinYear, setSelectedFinYear] = useState('All');
    const [finYear, setFinYear] = useState('');
    // queryParams drives the React Query fetch; null = no search yet
    const [queryParams, setQueryParams] = useState(null);
    // validation error shown before submit (separate from API errors)
    const [validationMsg, setValidationMsg] = useState('');
    const [isStateFrozen, setIsStateFrozen] = useState(false);
    const [isDistrictFrozen, setIsDistrictFrozen] = useState(false);
    const [isUserTypeFrozen, setIsUserTypeFrozen] = useState(false);
    const [desiredDistrictCode, setDesiredDistrictCode] = useState(null);
    const [isStateOrDistrictUser, setIsStateOrDistrictUser] = useState(false);
    const hasCalledStateUserApi = useRef(false);
    
    // Modal states for implements
    const [showImplementsModal, setShowImplementsModal] = useState(false);
    const [selectedImplements, setSelectedImplements] = useState(null);
    const [loadingImplements, setLoadingImplements] = useState(false);
    
    // Modal states for polygon
    const [showPolygonModal, setShowPolygonModal] = useState(false);
    const [selectedPolygon, setSelectedPolygon] = useState(null);
    const [polygonMap, setPolygonMap] = useState(null);
    const [imageRotations, setImageRotations] = useState({});
    const [previewImage, setPreviewImage] = useState(null);
    
    // Keep same loader options across pages to avoid
    // "Loader must not be called again with different options" crash.
    const mapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY
        || "AIzaSyD4X4kzlpReymgcXUXGh0Q3TalmxJmasM0";
    const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: mapsApiKey,
    });
    
    // State to track if search has been performed
    const [hasSearched, setHasSearched] = useState(false);
    
    // Key to force Select components to re-render when cleared
    const [selectKey, setSelectKey] = useState(0);
    
    // State for user type selection (temporary - changes on dropdown)
    const [selectedUserType, setSelectedUserType] = useState(null);
    // State for applied user type (used for table columns - only updates on Submit)
    const [appliedUserType, setAppliedUserType] = useState(null);
    
    // User type options
    const userTypeOptions = [
        // { value: '1', label: 'FMTTI' },
        { value: '2', label: 'CRM' },
        { value: '3', label: 'SMAM' }
    ];

    // SMAM login → only SMAM; CRM login / central admin → CRM + SMAM both
    const loggedInSchemeType = sessionStorage.getItem("userTypeCodeModel");
    const availableUserTypeOptions = loggedInSchemeType === '3'
        ? userTypeOptions.filter(opt => opt.value === '3')
        : userTypeOptions;

    // CRM ke liye sirf 5 states allowed hain
    const CRM_ALLOWED_STATES = ['Delhi', 'Haryana', 'Madhya Pradesh', 'Punjab', 'Uttar Pradesh'];

    const filteredStateOptions = selectedUserType === '2'
        ? optionState.filter(opt => CRM_ALLOWED_STATES.includes(opt.label))
        : optionState;

    // table utilities: sorting and pagination
    const [sortKey, setSortKey] = useState('');
    const [sortDir, setSortDir] = useState('asc'); // 'asc' | 'desc'
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const baseUrl = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE;
    const queryClient = useQueryClient();

    // ── React Query: survey data fetch ───────────────────────────────────────
    const {
        data: queryData,
        isLoading,
        error: queryError,
    } = useQuery({
        queryKey: ['surveyDetail', queryParams],
        queryFn: async () => {
            const res = await axios.post(
                `${baseUrl}/api/MT/CHCSurveyDetail`,
                queryParams,
                { headers: { 'Content-Type': 'application/json', accept: '*/*' } }
            );
            const content = res?.data?.dataContent ?? [];
            return Array.isArray(content) ? content : [];
        },
        enabled: queryParams !== null,
        staleTime: 5 * 60 * 1000,   // 5 min tak same filters ka result cache se milega
        gcTime:    10 * 60 * 1000,
        retry: 1,
        refetchOnWindowFocus: false,
    });

    // Derived values — used throughout component like the old state variables
    const rows         = queryData ?? [];
    const loading      = isLoading;
    const errorMessage = queryError
        ? 'Unable to fetch survey data. Please check your connection and try again. If the problem persists, contact your administrator.'
        : '';

    const [finYears, setFinYears] = useState(() => {
          const currentYear = new Date().getFullYear();
          const years = ["All"];
      
          // Add last 5 financial years
          for (let i = 0; i < 16; i++) {
            const startYear = currentYear - i;
            const endYear = startYear + 1;
            years.push(`${startYear}-${endYear}`);
          }
      
          return years;
        });
    useEffect(() => {
        getStates();
        // Prefill and freeze based on user type (State/District)
        const userType = sessionStorage.getItem("userRoleCodeModel");
      //  alert(userType);
        // Some logins stored state code under stateNameModel; use it as fallback
        const stateCodeStr = sessionStorage.getItem("stateCodeModel") || sessionStorage.getItem("stateNameModel");
        // Try multiple session storage keys for district information
        const districtCodeStr = sessionStorage.getItem("districtCodeModel") || sessionStorage.getItem("districtNameModel");
        
        const userTypeCodeModel = sessionStorage.getItem("userTypeCodeModel");

        if (userTypeCodeModel === '3') {
            setSelectedUserType('3');
            setAppliedUserType('3');
            setIsUserTypeFrozen(true);
        } else if (userTypeCodeModel === '2') {
            setSelectedUserType('2');
            setAppliedUserType('2');
            setIsUserTypeFrozen(false);
        }
        
        if (userType === "2" && stateCodeStr) { // State login
            const sc = Number(stateCodeStr);
            setStateValue([sc]);
            setIsStateFrozen(true);
            setIsStateOrDistrictUser(true);
            handleState(sc);
        }

        if (userType === "3" && stateCodeStr) { // District login
            const sc = Number(stateCodeStr);
            setStateValue([sc]);
            setIsStateFrozen(true);
            setIsStateOrDistrictUser(true);
            handleState(sc);

            if (districtCodeStr) {
                // Check if user has multiple districts
                const hasMultipleDistricts = String(districtCodeStr).includes(',');
                
                if (hasMultipleDistricts) {
                    // Multiple districts: DON'T freeze and DON'T auto-select - let user choose
                    setIsDistrictFrozen(false);
                } else {
                    // Single district: auto-select and freeze the dropdown
                    setDesiredDistrictCode(districtCodeStr);
                    setIsDistrictFrozen(true);
                }
            }
        }
    }, []);

    // Once districts are loaded and we have a desired district code, set it
    useEffect(() => {
        if (desiredDistrictCode && optionDistrict && optionDistrict.length > 0) {
            // Try to match by district code first
            let match = optionDistrict.find(o => Number(o.value) === Number(desiredDistrictCode));
            
            // If no match by code, try matching by district name (case-insensitive)
            if (!match && isNaN(Number(desiredDistrictCode))) {
                match = optionDistrict.find(o => 
                    o.label && o.label.toLowerCase() === String(desiredDistrictCode).toLowerCase()
                );
            }
            
            if (match) {
                handleChangeDistrict(match);
                setDesiredDistrictCode(null);
                // Don't fetch here - let the next useEffect handle it after state updates
            }
        }
    }, [optionDistrict, desiredDistrictCode]);

    // For district users: once district is frozen and selectedDataSetDistrict is set, fetch data
    useEffect(() => {
        if (isDistrictFrozen && selectedDataSetDistrict && selectedDataSetDistrict !== '') {
            setHasSearched(true);
            triggerFetch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDistrictFrozen, selectedDataSetDistrict]);

    // For state users: once state is frozen and set, fetch data
    useEffect(() => {
        if (isStateFrozen && stateValue && stateValue.length > 0 && !desiredDistrictCode && !isDistrictFrozen) {
            if (!hasCalledStateUserApi.current) {
                hasCalledStateUserApi.current = true;
                setHasSearched(true);
                triggerFetch();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isStateFrozen, stateValue, isDistrictFrozen, desiredDistrictCode]);

    // Central Admin users must use the Submit button — no auto-fetch on user type selection.

    function getStates() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            redirect: "follow",
        };
        fetch(
            `${baseUrl}/api/states`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => {
                let localFormDataState = JSON.parse(result).dataContent || [];
                let myArray = [];
                localFormDataState.map((item) => {
                    myArray.push({
                        value: item.stateCode,
                        label: item.stateName,
                    });
                });
                setOptionState(myArray);
            })
            .catch((error) => {
                console.error("Error fetching states:", error);
            });
    }

    function handleState(stateCodeParam = null) {
        const currentStateValue = stateCodeParam ? [stateCodeParam] : stateValue;
        setOptionDistrict([]);
        setDistrictValue('');
        setOptionSubDistrict([]);
        setsubDistrictValue('');
        setOptionVillage([]);
        setvillageValue('');

        if (currentStateValue && currentStateValue.length > 0) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            let stateValueData = "";
            currentStateValue.map((item) => { stateValueData = stateValueData + item + ","; });
            stateValueData = stateValueData.slice(0, -1);

            var raw = JSON.stringify({ stateCode: stateValueData.toString() });
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            fetch(
                `${baseUrl}/api/district`,
                requestOptions
            )
                .then((response) => response.text())
                .then((result) => {
                    let localFormDataDistrict = JSON.parse(result).dataContent || [];
                    let myArrayDistrict = [];
                    
                    // Filter districts for district users to only show assigned districts
                    const userType = sessionStorage.getItem("userRoleCodeModel");
                    const districtCodeStr = sessionStorage.getItem("districtCodeModel");
                    
                    if (userType === "3" && districtCodeStr) {
                        // District user: filter to only assigned districts
                        const assignedDistrictCodes = String(districtCodeStr).split(',').map(code => code.trim());
                        
                        localFormDataDistrict = localFormDataDistrict.filter(item => 
                            assignedDistrictCodes.includes(String(item.districtCode))
                        );
                    }
                    
                    localFormDataDistrict.map((item) => {
                        myArrayDistrict.push({ label: item.districtName, value: item.districtCode, stateid: item.stateCode })
                    })
                    setOptionDistrict(myArrayDistrict);
                })
                .catch((error) => console.log("error", error));
        }
    }

    let handleChangeDistrict = (selectedOption) => {
        setOptionSubDistrict([]);
        setsubDistrictValue('');
        setOptionVillage([]);
        setvillageValue('');

        if (selectedOption) {
            setDistrictValue(selectedOption.value);
            setselectedDataSetDistrict(`${selectedOption.stateid}|${selectedOption.value}`);

            let stateValueData = stateValue[0];
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var raw = JSON.stringify({
                stateCode: stateValueData?.toString() || "0",
                districtCode: selectedOption.value?.toString() || "0"
            });
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            fetch(
                `${baseUrl}/api/subdistrict`,
                requestOptions
            )
                .then((response) => response.text())
                .then((result) => {
                    let localFormDataSubDistrict = JSON.parse(result).dataContent || [];
                    let myArraySubDistrict = [];
                    localFormDataSubDistrict.map((item) => {
                        myArraySubDistrict.push({ label: item.subDistrictName, value: item.subDistrictCode, districtCode: item.districtCode })
                    });
                    setOptionSubDistrict(myArraySubDistrict);
                })
                .catch((error) => console.log("error", error));
        } else {
            setDistrictValue('');
            setselectedDataSetDistrict('');
            setOptionSubDistrict([]);
        }
    };

    let handleChangeSubDistrict = (selectedOption) => {
        setOptionVillage([]);
        setvillageValue('');
        if (selectedOption) {
            setsubDistrictValue(selectedOption.value);
            setselectedDataSetSubDistrict(`${selectedOption.districtCode}|${selectedOption.value}`);

            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            let stateValueData = stateValue[0] || 0;
            let districtValueData = districtValue || 0;
            var raw = JSON.stringify({
                stateCode: stateValueData.toString(),
                districtCode: districtValueData.toString(),
                subDistrictCode: selectedOption.value.toString()
            });
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            fetch(
                `${baseUrl}/api/village`,
                requestOptions
            )
                .then((response) => response.text())
                .then((result) => {
                    let localFormDataVillage = JSON.parse(result).dataContent || [];
                    let myArrayVillage = [];
                    localFormDataVillage.map((item) => {
                        myArrayVillage.push({ label: item.villageName, value: item.villageCode, subDistrictCode: item.subDistrictCode })
                    })
                    setOptionVillage(myArrayVillage)
                })
                .catch((error) => console.log("error", error));
        } else {
            setsubDistrictValue('');
            setselectedDataSetSubDistrict('');
        }
    };

    let handleChangeVillage = (selectedOption) => {
        if (selectedOption) {
            setvillageValue(selectedOption.value);
            setselectedDataSetVillage(`${selectedOption.subDistrictCode}|${selectedOption.value}`);
        } else {
            setvillageValue('');
            setselectedDataSetVillage('');
        }
    };

    let handleChangeStateSelect = (selectedOption) => {
        if (isStateFrozen) {
            return; // Prevent changes when frozen
        }
        setStateValue(selectedOption ? [selectedOption.value] : []);
        setValidationMsg('');
        if (!selectedOption) {
            setOptionDistrict([]);
            setDistrictValue('');
            setOptionSubDistrict([]);
            setsubDistrictValue('');
            setOptionVillage([]);
            setvillageValue('');
            setselectedDataSetDistrict('');
            setselectedDataSetSubDistrict('');
            setselectedDataSetVillage('');
            setQueryParams(null);
        } else {
            // Clear district, sub-district, and village when state changes
            setOptionDistrict([]);
            setDistrictValue('');
            setselectedDataSetDistrict('');
            setOptionSubDistrict([]);
            setsubDistrictValue('');
            setselectedDataSetSubDistrict('');
            setOptionVillage([]);
            setvillageValue('');
            setselectedDataSetVillage('');
            // Increment selectKey to force Select components to re-render
            setSelectKey(prev => prev + 1);
            // load districts for the new state
            handleState(selectedOption.value);
        }
    };

    // Convert UI finYear like "2023-2024" to API format "2023-24"
    const formatFinYearForApi = (value) => {
        if (!value) return "";
        const str = String(value).trim();
        const match = str.match(/^(\d{4})-(\d{2,4})$/);
        if (!match) return str; // already in desired shape or unsupported
        const start = match[1];
        const endTwo = match[2].slice(-2);
        return `${start}-${endTwo}`;
    };

    // Builds the API payload from current filter state
    const buildCurrentParams = () => {
        const stateCodeData = (stateValue && stateValue.length > 0) ? Number(stateValue[0]) : 0;
        const districtCodeData    = selectedDataSetDistrict    ? Number(selectedDataSetDistrict.split('|')[1]    || 0) : 0;
        const subDistrictCodeData = selectedDataSetSubDistrict ? Number(selectedDataSetSubDistrict.split('|')[1] || 0) : 0;
        const villageCodeData     = selectedDataSetVillage     ? Number(selectedDataSetVillage.split('|')[1]     || 0) : 0;

        const finYearToSend = (selectedFinYear && selectedFinYear !== 'All') ? selectedFinYear : (finYear || "");
        return {
            userTypeCode:    Number(selectedUserType ?? 0),
            finYear:         formatFinYearForApi(finYearToSend),
            stateCode:       stateCodeData,
            districtCode:    districtCodeData,
            subdistrictCode: subDistrictCodeData,
            villageCode:     villageCodeData,
        };
    };

    // Sets query params → triggers React Query fetch (cached if same params)
    const triggerFetch = () => setQueryParams(buildCurrentParams());

    function ValidateAndSearch() {
        // Validate that at least one filter is selected
        const hasUserType = selectedUserType && selectedUserType !== null;
        const hasFinYear = selectedFinYear && selectedFinYear !== 'All';
        const hasState = stateValue && stateValue.length > 0;
        const hasDistrict = districtValue && districtValue !== '';
        const hasSubDistrict = subdistrictValue && subdistrictValue !== '';
        const hasVillage = villageValue && villageValue !== '';
        
        // Check if at least one filter is selected
        const hasAnyFilter = hasUserType || hasFinYear || hasState || hasDistrict || hasSubDistrict || hasVillage;
        
        if (!hasAnyFilter) {
            setValidationMsg('Please select User Type before submitting your search.');
            setHasSearched(false);
            return;
        }

        setValidationMsg('');
        setHasSearched(true);
        // Apply the selected user type to table columns (only updates on Submit)
        setAppliedUserType(selectedUserType);
        triggerFetch();
    }

    function ClearSearch() {
        setFinYear('');
        setSelectedFinYear('All');
        if (!isUserTypeFrozen) {
            setSelectedUserType(null);
            setAppliedUserType(null);
        }
        if (!isStateFrozen) {
            setStateValue([]);
        }
        // Clear all district, sub-district, and village fields
        if (!isDistrictFrozen) {
            setDistrictValue('');
            setselectedDataSetDistrict('');
        }
        setsubDistrictValue('');
        setselectedDataSetSubDistrict('');
        setvillageValue('');
        setselectedDataSetVillage('');
        // Clear all options
        setOptionDistrict([]);
        setOptionSubDistrict([]);
        setOptionVillage([]);
        setHasSearched(false);
        setValidationMsg('');
        // Reset query so table is cleared and no stale data shows
        setQueryParams(null);
        // Increment selectKey to force Select components to re-render
        setSelectKey(prev => prev + 1);
    }

    // ── Table: memoised helpers ───────────────────────────────────────────────

    const columns = useMemo(() => {
        const baseColumns = [
            { key: 'finYear',            label: 'Fin Year' },
            { key: 'chcName',            label: 'CHC Name' },
            { key: 'mobileNo',           label: 'Mobile Number' },
            { key: 'contactPersonName',  label: 'Contact Person Name' },
            { key: 'stateName',          label: 'State' },
            { key: 'districtName',       label: 'District' },
            { key: 'subdistrictName',    label: 'Sub District' },
            { key: 'villageName',        label: 'Village' },
            { key: 'userTypeName',       label: 'Scheme' },
            { key: 'noOfImplements',     label: 'No. of Implement' },
            { key: 'polygonShape',       label: 'Detail' },
        ];
        const crmColumns = [
            { key: 'additionalRequirement', label: 'Additional Requirement' },
            { key: 'paddyArea_Ha',          label: 'Peddy Area (Ha)' },
            { key: 'nearbyPlantAddress',    label: 'Plant Address' },
        ];
        return appliedUserType === '2' ? [...baseColumns, ...crmColumns] : baseColumns;
    }, [appliedUserType]);

    const getValue = useCallback((row, key) => {
        if (key === 'subdistrictName') {
            return row.subdistrictName ?? row.subDistrictName ?? '';
        }
        return row[key] ?? '';
    }, []);

    const handleSort = useCallback((key) => {
        setSortKey(prev => {
            if (prev === key) {
                setSortDir(d => (d === 'asc' ? 'desc' : 'asc'));
                return prev;
            }
            setSortDir('asc');
            return key;
        });
        setCurrentPage(1);
    }, []);

    const sortedRows = useMemo(() => {
        if (!sortKey || !rows || rows.length === 0) return rows;
        const data = [...rows];
        data.sort((a, b) => {
            const av = String(getValue(a, sortKey)).toLowerCase();
            const bv = String(getValue(b, sortKey)).toLowerCase();
            if (av < bv) return sortDir === 'asc' ? -1 : 1;
            if (av > bv) return sortDir === 'asc' ? 1 : -1;
            return 0;
        });
        return data;
    }, [rows, sortKey, sortDir, getValue]);

    const totalItems  = sortedRows.length;
    const totalPages  = useMemo(() => Math.max(1, Math.ceil(totalItems / pageSize)), [totalItems, pageSize]);
    const safePage    = useMemo(() => Math.min(currentPage, totalPages), [currentPage, totalPages]);
    const pageRows    = useMemo(() => {
        const start = (safePage - 1) * pageSize;
        return sortedRows.slice(start, start + pageSize);
    }, [sortedRows, safePage, pageSize]);

    const goToPage = useCallback((p) => {
        setCurrentPage(prev => {
            const np = Math.min(Math.max(1, p), Math.max(1, Math.ceil(rows.length / pageSize)));
            return np;
        });
    }, [rows.length, pageSize]);

    const formatCsvCell = (key, rawValue) => {
        const val = String(rawValue ?? '').replace(/"/g, '""');
        // Excel scientific notation avoid — mobile as text
        if (key === 'mobileNo' && val) {
            return `"=""${val}"""`;
        }
        return `"${val}"`;
    };

    const exportToCsv = useCallback(() => {
        const exportColumns = columns.filter(c => c.key !== 'polygonShape');
        const header = exportColumns.map(c => c.label).join(',');
        const allRows = sortedRows.map(r =>
            exportColumns.map(c => formatCsvCell(c.key, getValue(r, c.key))).join(',')
        );
        const csv = [header, ...allRows].join('\n');
        const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
        const url  = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'survey_detail.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }, [columns, sortedRows, getValue]);

    // ── Handlers for modals ───────────────────────────────────────────────────
    const parseImagePaths = (imagePath) => {
        if (!imagePath) return [];
        return String(imagePath).split(',').map(path => path.trim()).filter(path => path);
    };

    const handleImplementsClick = async (row) => {
        // Get CHC ID from row - try multiple possible field names
        const chcId = row.id || row.chcId || row.chcid || row.chcID;
        
        if (!chcId) {
            alert('CHC ID not found in the record');
            return;
        }

        setLoadingImplements(true);
        setShowImplementsModal(true);
        setSelectedImplements(null);

        try {
            const userTypeCode = parseInt(sessionStorage.getItem("userTypeCodeModel") || sessionStorage.getItem("userRoleCodeModel") || "2");
            
            const { data } = await axios.post(
                `${baseUrl}/api/MT/Get_CHCImpByID`,
                {
                    chcid: parseInt(chcId),
                    userTypeCode: userTypeCode
                },
                {
                    headers: {
                        'accept': '*/*',
                        'Content-Type': 'application/json'
                    }
                }
            );

            console.log('Implement Details API Response:', data);

            if (data && data.success && data.dataContent) {
                // Flatten the nested structure: each category can have multiple implements
                const flattenedImplements = [];
                let totalImplements = 0;
                
                data.dataContent.forEach((category) => {
                    if (category.implements && Array.isArray(category.implements)) {
                        category.implements.forEach((implement) => {
                            flattenedImplements.push({
                                categoryName: category.categoryName || 'N/A',
                                implementName: implement.implementName || 'N/A',
                                implementID: implement.implementID,
                                implementCount: implement.implementCount,
                                isWorking: implement.isWorking,
                                areaCovered: implement.areaCovered
                            });
                            totalImplements++;
                        });
                    }
                });
                
                // Transform the response to match the expected format
                const implementData = {
                    chcName: row.chcName || 'N/A',
                    noOfImplements: totalImplements,
                    implementDetailsJSON: JSON.stringify(flattenedImplements)
                };
                setSelectedImplements(implementData);
            } else {
                // If no data, still show the modal with empty data
                setSelectedImplements({
                    chcName: row.chcName || 'N/A',
                    noOfImplements: 0,
                    implementDetailsJSON: JSON.stringify([])
                });
            }
        } catch (error) {
            console.error('Error fetching implement details:', error);
            alert('Failed to load implement details. Please try again.');
            setShowImplementsModal(false);
        } finally {
            setLoadingImplements(false);
        }
    };

    const closeImplementsModal = () => {
        setShowImplementsModal(false);
        setSelectedImplements(null);
        setLoadingImplements(false);
    };

    const handlePolygonClick = (rowData) => {
        setSelectedPolygon(rowData);
        setImageRotations({});
        setPreviewImage(null);
        setShowPolygonModal(true);
    };

    const closePolygonModal = () => {
        setShowPolygonModal(false);
        setSelectedPolygon(null);
        setPolygonMap(null);
        setImageRotations({});
        setPreviewImage(null);
    };

    const rotateChcImage = (index, delta) => {
        setImageRotations((prev) => {
            const current = prev[index] || 0;
            return { ...prev, [index]: (current + delta + 360) % 360 };
        });
    };

    const renderRows = () => {
        if (!rows || rows.length === 0) return null;

        return (
            <div className="table-responsive">
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <div className="d-flex align-items-center gap-2">
                        <label className="me-2">Page size</label>
                        <select
                            className="form-select form-select-sm"
                            style={{ width: 90 }}
                            value={pageSize}
                            onChange={(e) => { setPageSize(Number(e.target.value)); setCurrentPage(1); }}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                        <span className="ms-3">Total: {totalItems}</span>
                    </div>
                    <button type="button" className="btn btn-outline-primary btn-sm" onClick={exportToCsv}>Export CSV</button>
                </div>
                <table className="table table-bordered table-striped table-sm">
                    <thead>
                        <tr>
                            {columns.map((c) => (
                                <th
                                    key={c.key}
                                    role="button"
                                    onClick={() => handleSort(c.key)}
                                    title="Click to sort"
                                >
                                    {c.label}
                                    {sortKey === c.key ? (
                                        <span className="ms-1">{sortDir === 'asc' ? '▲' : '▼'}</span>
                                    ) : null}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {pageRows.map((r, idx) => (
                            <tr key={r.id ?? idx}>
                                {columns.map((c) => (
                                    <td key={c.key}>
                                        {c.key === 'noOfImplements' ? (
                                            <a
                                                href="#!"
                                                onClick={(e) => { e.preventDefault(); handleImplementsClick(r); }}
                                                className="text-primary"
                                                style={{ cursor: 'pointer', color:'white', textDecoration: 'underline' }}
                                                title="View Implement Details"
                                            >
                                                {String(getValue(r, 'noOfImplements') || '0')}
                                            </a>
                                        ) : c.key === 'polygonShape' ? (
                                            <button
                                                className="btn btn-sm btn-link p-0"
                                                onClick={() => handlePolygonClick(r)}
                                                title="View Detail"
                                            >
                                                <i className="bi bi-eye-fill" style={{ fontSize: '1.2rem', color: '#28a745' }}></i>
                                            </button>
                                        ) : (
                                            String(getValue(r, c.key))
                                        )}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className="d-flex align-items-center justify-content-between">
                    <div>
                        Page {safePage} of {totalPages}
                    </div>
                    <div className="btn-group btn-group-sm" role="group">
                        <button type="button" className="btn btn-outline-secondary" onClick={() => goToPage(1)} disabled={safePage === 1}>{'<<'}</button>
                        <button type="button" className="btn btn-outline-secondary" onClick={() => goToPage(safePage - 1)} disabled={safePage === 1}>{'<'}</button>
                        <button type="button" className="btn btn-outline-secondary" onClick={() => goToPage(safePage + 1)} disabled={safePage === totalPages}>{'>'}</button>
                        <button type="button" className="btn btn-outline-secondary" onClick={() => goToPage(totalPages)} disabled={safePage === totalPages}>{'>>'}</button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <AdminHeaderNew />
            <AdminSideBarNew />

            <main id="main" className="main">
                <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
                    <nav>
                        <h1>Survey List</h1>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Survey</li>
                            <li className="breadcrumb-item active">CHC Survey Detail</li>
                            <li className="breadcrumb-item">
                                {(() => {
                                    const userTypeCode = Number(sessionStorage.getItem("userTypeCodeModel"));
                                    switch(userTypeCode) {
                                        case 1: return "FMTTI";
                                        case 2: return "CRM";
                                        case 3: return "SMAM";
                                        
                                    }
                                })()}
                            </li>
                        </ol>
                    </nav>
                </div>

                <section className="section">
                    <div className="row surveydetailsBg">
                        <div className="col-md-3">
                        <label htmlFor="userTypeDropdown" className="form-label">User Type</label>
                        <Select
                            id="userTypeDropdown"
                            options={availableUserTypeOptions}
                            value={availableUserTypeOptions.find(opt => opt.value === selectedUserType) || null}
                            onChange={opt => {
                                const newType = opt ? opt.value : null;
                                setSelectedUserType(newType);
                                // CRM select hone par agar selected state allowed list mein nahi hai to clear karo
                                if (newType === '2' && stateValue && stateValue.length > 0) {
                                    const selectedStateLabel = optionState.find(s => s.value === stateValue[0])?.label;
                                    if (!CRM_ALLOWED_STATES.includes(selectedStateLabel)) {
                                        setStateValue([]);
                                        setOptionDistrict([]);
                                        setDistrictValue('');
                                        setOptionSubDistrict([]);
                                        setsubDistrictValue('');
                                        setOptionVillage([]);
                                        setvillageValue('');
                                    }
                                }
                            }}
                            isClearable={!isUserTypeFrozen}
                            isSearchable={false}
                            placeholder="Select Component Type"
                            classNamePrefix="select"
                            isDisabled={isUserTypeFrozen}
                        />
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="finYear" className="form-label">Fin Year</label>
                            <Select
                                options={finYears.map(y => ({ label: y, value: y }))}
                                value={selectedFinYear ? { value: selectedFinYear, label: selectedFinYear } : null}
                                onChange={(opt) => setSelectedFinYear(opt ? opt.value : 'All')}
                                isClearable={true}
                                isSearchable={true}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select Fin Year"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>{children}</components.Option>
                                    )
                                }}
                            />
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="State" className="form-label">State</label>
                            <Select
                                options={filteredStateOptions}
                                value={stateValue && stateValue.length > 0 ? filteredStateOptions.find(option => option.value === stateValue[0]) : null}
                                onChange={handleChangeStateSelect}
                                isClearable={true}
                                isSearchable={true}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select State"
                                classNamePrefix="select"
                                isDisabled={isStateFrozen}
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>{children}</components.Option>
                                    )
                                }}
                            />
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="District" className="form-label">District</label>
                            <Select
                                key={`district-${selectKey}`}
                                options={optionDistrict}
                                value={optionDistrict.find(option => option.value === districtValue)}
                                onChange={handleChangeDistrict}
                                isClearable={true}
                                isSearchable={true}
                                placeholder="Select District"
                                classNamePrefix="select"
                                isDisabled={isDistrictFrozen}
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>{children}</components.Option>
                                    )
                                }}
                            />
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="SubDistrict" className="form-label">Sub District</label>
                            <Select
                                key={`subdistrict-${selectKey}`}
                                options={optionSubDistrict}
                                value={optionSubDistrict.find(option => option.value === subdistrictValue)}
                                onChange={handleChangeSubDistrict}
                                isClearable={true}
                                isSearchable={true}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select Sub District"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>{children}</components.Option>
                                    )
                                }}
                            />
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="Village" className="form-label">Village</label>
                            <Select
                                key={`village-${selectKey}`}
                                options={optionVillage}
                                value={optionVillage.find(option => option.value === villageValue)}
                                onChange={handleChangeVillage}
                                isClearable={true}
                                isSearchable={true}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select Village"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>{children}</components.Option>
                                    )
                                }}
                            />
                        </div>

                        <div className="col-md-12 d-flex justify-content-md-center mt-3">
                            <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={ValidateAndSearch} disabled={loading}>{loading ? 'Searching...' : 'Submit'}</button>
                            <button type="button" className="btn btn-success me-md-2" onClick={ClearSearch}>Clear</button>
                        </div>
                    </div>

                    {validationMsg && (
                        <div className="alert alert-danger mt-3" role="alert">{validationMsg}</div>
                    )}
                    {hasSearched && errorMessage && (
                        <div className="alert alert-danger mt-3" role="alert">{errorMessage}</div>
                    )}

                    {hasSearched && (
                        <div className="row mt-3">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        {rows.length > 0 ? (
                                            renderRows()
                                        ) : (
                                            <div className="alert alert-info" role="alert">
                                                No survey records found matching your selected filters.
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </section>

                {loading === false ? "" : <div className="overlay"><div className="overlay__inner"><div className="overlay__content"><span className="spinner"></span></div></div></div>}
                
                {/* Polygon Modal */}
                {showPolygonModal && selectedPolygon && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={closePolygonModal}>
                        <div className="modal-dialog modal-dialog-centered modal-xl" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Details</h5>
                                    <button type="button" className="btn-close" onClick={closePolygonModal}>x</button>
                                </div>
                                <div className="modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                                    {/* {isLoaded ? (
                                        <GoogleMap
                                            mapContainerStyle={{ width: "100%", height: "50vh" }}
                                            center={{ lat: 28.641832439372656, lng: 77.22480777651072 }}
                                            zoom={18}
                                            onLoad={(map) => {
                                                setPolygonMap(map);
                                                try {
                                                    const polygonData = JSON.parse(selectedPolygon.polygonShape);
                                                    const polygon = new window.google.maps.Polygon({
                                                        paths: polygonData,
                                                        strokeColor: "#FF0000",
                                                        strokeOpacity: 1,
                                                        strokeWeight: 2,
                                                        fillColor: "#FF0000",
                                                        fillOpacity: 0.1,
                                                    });
                                                    
                                                    polygon.setMap(map);
                                                    
                                                    // Calculate and set bounds
                                                    const bounds = new window.google.maps.LatLngBounds();
                                                    polygonData.forEach(point => {
                                                        bounds.extend(new window.google.maps.LatLng(point.lat, point.lng));
                                                    });
                                                    map.fitBounds(bounds);
                                                    
                                                    // Add marker at center
                                                    const center = bounds.getCenter();
                                                    const marker = new window.google.maps.Marker({
                                                        position: center,
                                                        map: map,
                                                        title: "Click to zoom",
                                                    });
                                                    
                                                    marker.addListener("click", () => {
                                                        map.panTo(marker.getPosition());
                                                        map.setZoom(18);
                                                    });
                                                } catch (error) {
                                                    console.error("Error rendering polygon:", error);
                                                }
                                            }}
                                            onUnmount={() => setPolygonMap(null)}
                                            mapTypeId="satellite"
                                        />
                                    ) : (
                                        <div style={{ width: "100%", height: "50vh", display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f0f0f0' }}>
                                            <div className="text-center">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                                <p className="mt-2">Loading map...</p>
                                            </div>
                                        </div>
                                    )} */}
                                    
                                    <div className="mt-4">
                                        <h6 className="mb-3"><strong>Survey Details</strong></h6>
                                        <div className="row surveydetailsbg">
                                            <div className="col-md-3 mb-3">
                                                <h6>CHC Name</h6>
                                                <p>{selectedPolygon.chcName || 'N/A'}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Contact Person</h6>
                                                <p>{selectedPolygon.contactPersonName || 'N/A'}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Mobile Number</h6>
                                                <p>{selectedPolygon.mobileNo || 'N/A'}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Financial Year</h6>
                                                <p>{selectedPolygon.finYear || 'N/A'}</p>
                                            </div>
                                        </div>
                                        
                                        <h6 className="mb-3 mt-3"><strong>Location Details</strong></h6>
                                        <div className="row surveydetailsbg">
                                            <div className="col-md-3 mb-3">
                                                <h6>State</h6>
                                                <p>{selectedPolygon.stateName || 'N/A'}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>District</h6>
                                                <p>{selectedPolygon.districtName || 'N/A'}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Sub District</h6>
                                                <p>{selectedPolygon.subdistrictName || selectedPolygon.subDistrictName || 'N/A'}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Village</h6>
                                                <p>{selectedPolygon.villageName || 'N/A'}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Landmark Address</h6>
                                                <p>{selectedPolygon.landMarkAddress || 'N/A'}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Area Type</h6>
                                                <p>{selectedPolygon.areaType === "1" ? "Rural" : selectedPolygon.areaType === "2" ? "Urban" : 'N/A'}</p>
                                            </div>
                                        </div>
                                        
                                        {/* <h6 className="mb-3 mt-3"><strong>Polygon Information</strong></h6>
                                        <div className="row surveydetailsbg">
                                            <div className="col-md-3 mb-3">
                                                <h6>Polygon Area (sq.m)</h6>
                                                <p>{selectedPolygon.polygonArea || 'N/A'}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Image Latitude</h6>
                                                <p>{selectedPolygon.imageLat || 'N/A'}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Image Longitude</h6>
                                                <p>{selectedPolygon.imageLong || 'N/A'}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Surveyor Latitude</h6>
                                                <p>{selectedPolygon.surveyorLat || 'N/A'}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Surveyor Longitude</h6>
                                                <p>{selectedPolygon.surveyorLong || 'N/A'}</p>
                                            </div>
                                        </div> */}
                                        
                                        <h6 className="mb-3 mt-3"><strong>Additional Details</strong></h6>
                                        <div className="row surveydetailsbg">
                                            <div className="col-md-3 mb-3">
                                                <h6>Established By</h6>
                                                <p>{selectedPolygon.establishedByName}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Establishment Year</h6>
                                                <p>{selectedPolygon.year}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Establishment Month</h6>
                                                <p>{selectedPolygon.monthName}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Registration Number</h6>
                                                <p>{selectedPolygon.societyRegistrationNumber}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>GST Number</h6>
                                                <p>{selectedPolygon.gsT_NO}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Scheme Type</h6>
                                                <p>{selectedPolygon.userTypeName}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Under Scheme</h6>
                                                <p>{selectedPolygon.underSchemeName}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Component Name</h6>
                                                <p>{selectedPolygon.componentName}</p>
                                            </div>
                                            <div className="col-md-3 mb-3">
                                                <h6>Created Date</h6>
                                                <p>{selectedPolygon.createdOn ? selectedPolygon.createdOn.split('T')[0] : 'N/A'}</p>
                                            </div>
                                        </div>

                                        <h6 className="mb-3 mt-3"><strong>CHC Images</strong></h6>
                                        <div className="row surveydetailsbg">
                                            {parseImagePaths(selectedPolygon.imagePath).length > 0 ? (
                                                parseImagePaths(selectedPolygon.imagePath).map((imagePath, index) => {
                                                    const rotation = imageRotations[index] || 0;
                                                    const isSideways = rotation % 180 !== 0;
                                                    return (
                                                    <div className="col-md-4 mb-3" key={`${imagePath}-${index}`}>
                                                        <div
                                                            style={{
                                                                position: 'relative',
                                                                background: '#f4f4f4',
                                                                borderRadius: '6px',
                                                                overflow: 'hidden',
                                                                height: '220px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                        >
                                                            <img
                                                                src={imagePath}
                                                                alt={`CHC ${index + 1}`}
                                                                title="Click to view larger"
                                                                onClick={() => setPreviewImage({ src: imagePath, index })}
                                                                style={{
                                                                    width: isSideways ? '220px' : '100%',
                                                                    maxWidth: '100%',
                                                                    maxHeight: isSideways ? '100%' : '220px',
                                                                    objectFit: 'contain',
                                                                    borderRadius: '6px',
                                                                    transform: `rotate(${rotation}deg)${isSideways ? ' scale(0.75)' : ''}`,
                                                                    transition: 'transform 0.3s ease',
                                                                    cursor: 'zoom-in'
                                                                }}
                                                                onError={(e) => {
                                                                    e.target.onerror = null;
                                                                    e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="260" height="180"><rect width="100%" height="100%" fill="%23f2f2f2"/><text x="50%" y="50%" text-anchor="middle" dy=".3em" fill="%23999" font-size="14">Image not available</text></svg>';
                                                                }}
                                                            />
                                                            <div
                                                                className="d-flex gap-1"
                                                                style={{
                                                                    position: 'absolute',
                                                                    bottom: '8px',
                                                                    left: '50%',
                                                                    transform: 'translateX(-50%)',
                                                                    background: 'rgba(0,0,0,0.55)',
                                                                    borderRadius: '20px',
                                                                    padding: '4px 6px'
                                                                }}
                                                            >
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-light rounded-circle"
                                                                    title="Rotate left"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        rotateChcImage(index, -90);
                                                                    }}
                                                                    style={{ width: '32px', height: '32px', padding: 0 }}
                                                                >
                                                                    <i className="bi bi-arrow-counterclockwise"></i>
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-light rounded-circle"
                                                                    title="Rotate right"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        rotateChcImage(index, 90);
                                                                    }}
                                                                    style={{ width: '32px', height: '32px', padding: 0 }}
                                                                >
                                                                    <i className="bi bi-arrow-clockwise"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    );
                                                })
                                            ) : (
                                                <div className="col-12">
                                                    <p className="mb-0">No image available</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={closePolygonModal}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {previewImage && (
                    <div
                        style={{
                            position: 'fixed',
                            inset: 0,
                            zIndex: 1060,
                            background: 'rgba(0,0,0,0.88)',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '24px'
                        }}
                        onClick={() => setPreviewImage(null)}
                    >
                        <img
                            src={previewImage.src}
                            alt="CHC preview"
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                maxWidth: ((imageRotations[previewImage.index] || 0) % 180 === 0) ? '90vw' : '78vh',
                                maxHeight: ((imageRotations[previewImage.index] || 0) % 180 === 0) ? '78vh' : '90vw',
                                objectFit: 'contain',
                                borderRadius: '8px',
                                transform: `rotate(${imageRotations[previewImage.index] || 0}deg)`,
                                transition: 'transform 0.3s ease'
                            }}
                        />
                        <div
                            className="d-flex align-items-center gap-2 mt-3"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={() => rotateChcImage(previewImage.index, -90)}
                            >
                                <i className="bi bi-arrow-counterclockwise me-1"></i> Rotate Left
                            </button>
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={() => rotateChcImage(previewImage.index, 90)}
                            >
                                <i className="bi bi-arrow-clockwise me-1"></i> Rotate Right
                            </button>
                            <button
                                type="button"
                                className="btn btn-light"
                                onClick={() => setPreviewImage(null)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                )}
                
                {/* Implements Details Modal */}
                {showImplementsModal && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={closeImplementsModal}>
                        <div className="modal-dialog modal-dialog-centered modal-lg" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Implement Details</h5>
                                    <button type="button" className="btn-close" onClick={closeImplementsModal}>x</button>
                                </div>
                                <div className="modal-body">
                                    {loadingImplements ? (
                                        <div className="text-center py-4">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            <p className="mt-2 text-muted">Loading implement details...</p>
                                        </div>
                                    ) : selectedImplements ? (
                                        <>
                                            <div className="mb-3">
                                                <h6><strong>CHC Name:</strong> {selectedImplements.chcName || 'N/A'}</h6>
                                                <p className="mb-1"><strong>Total Implements:</strong> {selectedImplements.noOfImplements || 0}</p>
                                            </div>
                                            <div className="table-responsive">
                                                <table className="table table-bordered table-striped">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th>S.No</th>
                                                            <th>Category Name</th>
                                                            <th>Implement Name</th>
                                                            <th>No. of Implements</th>
                                                            {appliedUserType === '2' && (
                                                                <>
                                                                    <th>Is Working</th>
                                                                    {/* <th>No. of Implements</th> */}
                                                                    <th>Area Covered</th>
                                                                </>
                                                            )}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {(() => {
                                                            try {
                                                                const implementDetails = selectedImplements.implementDetailsJSON 
                                                                    ? JSON.parse(selectedImplements.implementDetailsJSON) 
                                                                    : [];
                                                                
                                                                if (implementDetails.length === 0) {
                                                                    const colSpan = appliedUserType === '2' ? 5 : 3;
                                                                    return (
                                                                        <tr>
                                                                            <td colSpan={colSpan} className="text-center">No implement details available</td>
                                                                        </tr>
                                                                    );
                                                                }
                                                                return implementDetails.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1}</td>
                                                                        <td>{item.categoryName || item.CategoryName}</td>
                                                                        <td>{item.implementName || item.ImplementName}</td>
                                                                        <td>{item.implementCount || item.implementCount}</td>
                                                                        {appliedUserType === '2' && (
                                                                            <>
                                                                                <td>{item.isWorking === "Y" ? "Working" : item.isWorking === "N" ? "Not Working" : ""}</td>
                                                                                {/* <td>{item.implementCount}</td> */}
                                                                                <td>{item.areaCovered}</td>
                                                                            </>
                                                                        )}
                                                                    </tr>
                                                                ));
                                                            } catch (error) {
                                                                console.error('Error parsing implement details:', error);
                                                                const colSpan = appliedUserType === '2' ? 5 : 3;
                                                                return (
                                                                    <tr>
                                                                        <td colSpan={colSpan} className="text-center text-danger">Error loading implement details</td>
                                                                    </tr>
                                                                );
                                                            }
                                                        })()}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="text-center py-4 text-muted">
                                            <p>No implement data available</p>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={closeImplementsModal}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </main>

            <AdminFooterNew />
        </>
    );
};

export default SurveyDetail;

 